// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
# Portfolio
--------------------------------------------------------------*/  
  .portfolio #portfolio-flters li:hover,
  .portfolio #portfolio-flters li.filter-active {
    background: #18d26e;
  }
  
  .portfolio #portfolio-flters li:last-child {
    margin-right: 0;
  }
  
  .portfolio .portfolio-wrap {
    transition: 0.3s;
    position: relative;
    background: rgba(0, 0, 0, 0.6);
  }
  
  .portfolio .portfolio-wrap::before {
    content: "";
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 30px;
    right: 30px;
    top: 30px;
    bottom: 30px;
    transition: all ease-in-out 0.3s;
    z-index: 2;
    opacity: 0;
  }
  
  .portfolio .portfolio-wrap .portfolio-info {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    z-index: 3;
    transition: all ease-in-out 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .portfolio .portfolio-wrap .portfolio-info::before {
    display: block;
    content: "";
    width: 48px;
    height: 48px;
    position: absolute;
    top: 35px;
    left: 35px;
    transition: all 0.5s ease 0s;
    z-index: 9994;
  }
  
  .portfolio .portfolio-wrap .portfolio-info::after {
    display: block;
    content: "";
    width: 48px;
    height: 48px;
    position: absolute;
    bottom: 35px;
    right: 35px;
    transition: all 0.5s ease 0s;
    z-index: 9994;
  }
  
  .portfolio .portfolio-wrap .portfolio-info h4 {
    font-size: 20px;
    color: #fff;
    font-weight: 600;
  }
  
  .portfolio .portfolio-wrap .portfolio-info p {
    color: #ffffff;
    font-size: 14px;
    text-transform: uppercase;
    padding: 0;
    margin: 0;
  }
  
  .portfolio .portfolio-wrap .portfolio-links {
    text-align: center;
    z-index: 4;
  }
  
  .portfolio .portfolio-wrap .portfolio-links a {
    color: #fff;
    margin: 0 2px;
    font-size: 28px;
    display: inline-block;
    transition: 0.3s;
  }

  .portfolio .portfolio-wrap:hover::before {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
  }
  
  .portfolio .portfolio-wrap:hover .portfolio-info {
    opacity: 1;
  }

.portfolio {
  position: absolute; 
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 60%;
  margin-top: -100px;
}

p.my-4 {
  color: white;
  text-align: center;
  font-size: 13px;
}

/*--------------------------------------------------------------
# Portfolio Details
--------------------------------------------------------------*/

.portfolio-details {
  color: white;
  overflow-y: auto;
}
.portfolio-details .portfolio-info,
.portfolio-details .portfolio-title {
  color: white;
  overflow-y: auto;
}

.details-button {
  margin-top: 100px;
}

.project-links a {
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  line-height: 1;
  margin-right: 8px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
}

.project-links a:hover {
  background: rgb(241, 137, 241);
}

.project-links {
  margin-top: 20px;
  display: flex;
}

.project-image {
  max-width: 50%;
  float: right; 
  margin-left: 20px; 
}
.portfolio-info::after {
  content: "";
  display: table;
  clear: both;
}

@media (max-width: 768px) {
  .portfolio {
    width: 100%;
    margin-top: 0;
  }
  .project-image {
    max-width: 100%;
    height: auto;
    float: none;
    margin-left: 0;
  }
  .portfolio-details .portfolio-info {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Projects.css"],"names":[],"mappings":"AAAA;;+DAE+D;EAC7D;;IAEE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;+DAE+D;;AAE/D;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/*--------------------------------------------------------------\n# Portfolio\n--------------------------------------------------------------*/  \n  .portfolio #portfolio-flters li:hover,\n  .portfolio #portfolio-flters li.filter-active {\n    background: #18d26e;\n  }\n  \n  .portfolio #portfolio-flters li:last-child {\n    margin-right: 0;\n  }\n  \n  .portfolio .portfolio-wrap {\n    transition: 0.3s;\n    position: relative;\n    background: rgba(0, 0, 0, 0.6);\n  }\n  \n  .portfolio .portfolio-wrap::before {\n    content: \"\";\n    background: rgba(0, 0, 0, 0.6);\n    position: absolute;\n    left: 30px;\n    right: 30px;\n    top: 30px;\n    bottom: 30px;\n    transition: all ease-in-out 0.3s;\n    z-index: 2;\n    opacity: 0;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-info {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    text-align: center;\n    z-index: 3;\n    transition: all ease-in-out 0.3s;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-info::before {\n    display: block;\n    content: \"\";\n    width: 48px;\n    height: 48px;\n    position: absolute;\n    top: 35px;\n    left: 35px;\n    transition: all 0.5s ease 0s;\n    z-index: 9994;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-info::after {\n    display: block;\n    content: \"\";\n    width: 48px;\n    height: 48px;\n    position: absolute;\n    bottom: 35px;\n    right: 35px;\n    transition: all 0.5s ease 0s;\n    z-index: 9994;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-info h4 {\n    font-size: 20px;\n    color: #fff;\n    font-weight: 600;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-info p {\n    color: #ffffff;\n    font-size: 14px;\n    text-transform: uppercase;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-links {\n    text-align: center;\n    z-index: 4;\n  }\n  \n  .portfolio .portfolio-wrap .portfolio-links a {\n    color: #fff;\n    margin: 0 2px;\n    font-size: 28px;\n    display: inline-block;\n    transition: 0.3s;\n  }\n\n  .portfolio .portfolio-wrap:hover::before {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 1;\n  }\n  \n  .portfolio .portfolio-wrap:hover .portfolio-info {\n    opacity: 1;\n  }\n\n.portfolio {\n  position: absolute; \n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  width: 60%;\n  margin-top: -100px;\n}\n\np.my-4 {\n  color: white;\n  text-align: center;\n  font-size: 13px;\n}\n\n/*--------------------------------------------------------------\n# Portfolio Details\n--------------------------------------------------------------*/\n\n.portfolio-details {\n  color: white;\n  overflow-y: auto;\n}\n.portfolio-details .portfolio-info,\n.portfolio-details .portfolio-title {\n  color: white;\n  overflow-y: auto;\n}\n\n.details-button {\n  margin-top: 100px;\n}\n\n.project-links a {\n  font-size: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  line-height: 1;\n  margin-right: 8px;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n}\n\n.project-links a:hover {\n  background: rgb(241, 137, 241);\n}\n\n.project-links {\n  margin-top: 20px;\n  display: flex;\n}\n\n.project-image {\n  max-width: 50%;\n  float: right; \n  margin-left: 20px; \n}\n.portfolio-info::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n@media (max-width: 768px) {\n  .portfolio {\n    width: 100%;\n    margin-top: 0;\n  }\n  .project-image {\n    max-width: 100%;\n    height: auto;\n    float: none;\n    margin-left: 0;\n  }\n  .portfolio-details .portfolio-info {\n    padding-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
